import { useFitScale } from '@/hooks/useFitScale'
import { BoardView } from './studio/BoardView'
import { ChatView } from './studio/ChatView'
import { FlowView } from './studio/FlowView'
import { StudioShell, type StudioMode } from './studio/StudioShell'

/**
 * A still of the studio window (desktop app 0.1.6) at 16:9, in one of its three
 * workspace modes. Designed at a fixed size and scaled to the container so it
 * reads like a screenshot.
 */
const W = 1120
const H = 630

const COUNT: Record<StudioMode, string> = { chat: '3 frames', board: '5 frames', flow: '5 nodes' }

export function ProductFrame({ mode = 'board' }: { mode?: StudioMode }) {
  const { ref, scale } = useFitScale(W)
  return (
    <div ref={ref} className="w-full" style={{ height: H * scale }}>
      <figure className="origin-top-left overflow-hidden" style={{ width: W, height: H, transform: `scale(${scale})` }}>
        <StudioShell mode={mode} count={COUNT[mode]}>
          {mode === 'chat' ? <ChatView /> : mode === 'board' ? <BoardView /> : <FlowView />}
        </StudioShell>
      </figure>
    </div>
  )
}
